import { Link } from '@fountain/fountain-ui-components';
import { Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { makeSelectWhoami } from 'containers/Auth_old/selectors';
import usePusherChannel from 'hooks/usePusherChannel';

import useStyles from './styles';

interface NotificationContentProp {
  message: string;
  url?: string;
}

const Notification = () => {
  const { accountSlug } = useParams<{ accountSlug: string }>();
  const currentUser = useSelector(makeSelectWhoami());

  const classes = useStyles();
  const [notificationContent, setNotificationContent] =
    useState<NotificationContentProp | null>(null);

  usePusherChannel(
    currentUser.external_id
      ? `${accountSlug ?? ''};user-notification;${currentUser.external_id}`
      : null,
    {
      notifications: (data: NotificationContentProp) =>
        setNotificationContent(data),
    },
  );

  const handleClose = () => {
    setNotificationContent(null);
  };

  return (
    <div data-testid="user-notification-bar">
      {notificationContent && (
        <Alert
          variant="filled"
          onClose={handleClose}
          icon={false}
          className={classes.alert}
        >
          <Typography variant="body1">
            {notificationContent?.url ? (
              <Link color="inherit" href={notificationContent.url}>
                {notificationContent?.message}
              </Link>
            ) : (
              notificationContent?.message
            )}
          </Typography>
        </Alert>
      )}
    </div>
  );
};

export default Notification;
